// Archivo: Pagination.jsx

import React from "react";
import { Box, Pagination } from "@mui/material";

const MembersTablePagination = ({ current, last, hasNext, hasPrev, onChange }) => {
  const handleChange = (_, value) => {
    onChange(value);
  };

  return (
    <Box display="flex" alignItems="center" gap={2} mb={8}>
      <Pagination
        count={last}
        page={current}
        onChange={handleChange}
        color="primary"
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
      />
    </Box>
  );
};

export default MembersTablePagination;
